import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Package, Lightbulb, Award, Mail } from 'lucide-react';
import { getProducts, getInnovations, getUSPs, getInquiries } from '../../api';

const Dashboard = () => {
  const [stats, setStats] = useState({
    products: 0,
    innovations: 0,
    usps: 0,
    inquiries: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [productsRes, innovationsRes, uspsRes, inquiriesRes] = await Promise.all([
        getProducts(),
        getInnovations(),
        getUSPs(),
        getInquiries()
      ]);

      setStats({
        products: productsRes.data.length,
        innovations: innovationsRes.data.length,
        usps: uspsRes.data.length,
        inquiries: inquiriesRes.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const statCards = [
    {
      title: 'Products',
      value: stats.products,
      icon: Package,
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: 'Innovations',
      value: stats.innovations,
      icon: Lightbulb,
      color: 'from-purple-500 to-purple-600'
    },
    {
      title: 'USPs',
      value: stats.usps,
      icon: Award,
      color: 'from-green-500 to-green-600'
    },
    {
      title: 'Inquiries',
      value: stats.inquiries,
      icon: Mail,
      color: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title}>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">{stat.title}</p>
                    <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
                  </div>
                  <div className={`w-12 h-12 bg-gradient-to-br ${stat.color} rounded-lg flex items-center justify-center`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Welcome to CJS Beverages Admin Panel</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            Manage your website content, products, and customer inquiries from this dashboard.
            Use the navigation menu on the left to access different sections.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard;
